// This is supposed to be the time zone of the Earzz as a company.
// Do not change. Do not use this for customer data.
export const EarzzOfficialTimeZoneId = 'Europe/London';
